export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/logoutIcon.2e1a2b7e.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};